import React from 'react';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  fab,
  faGithub,
  faFacebook,
  faLinkedin,
  faSlideshare,
  faTwitter
} from '@fortawesome/free-brands-svg-icons';
import {
  faLaptopCode,
  faDrawPolygon,
  faEdit,
  faBullhorn,
  faMapMarkerAlt,
  faPhone,
  faPaperPlane,
  faFeatherAlt,
  faMicrophoneAlt
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

/* add any additional icon to the library */
library.add(fab, faLaptopCode, faDrawPolygon, faEdit, faEdit, faBullhorn, faMapMarkerAlt, faPhone, faPaperPlane, faFeatherAlt, faMicrophoneAlt, faGithub, faFacebook, faLinkedin, faSlideshare, faTwitter );

export type IconProps = FontAwesomeIconProps['icon'];

const Icon: React.FC<FontAwesomeIconProps> = ({ ...props }) => <FontAwesomeIcon {...props} />;

export default Icon;
